import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const SuccessMessage = ({ message }) => (
    <div className="form-message success" role="alert">
        <FontAwesomeIcon icon={faCircleCheck} className="message-icon success" size="md" />
        <p className="form-message-text success">{message}</p>
    </div>
);

export default SuccessMessage;
